module.exports = __webpack_public_path__ + "static/media/slide1.cbfa32fe.png";